import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
//import { CoreEffects } from '../../state/effect/core.effects';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { OAuthService, JwksValidationHandler, AuthConfig } from 'angular-oauth2-oidc';
import { EventInteraction } from '../dynamic/event.interaction.service';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
//import { UserStatsService } from './user.stats.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router} from '@angular/router';

@Injectable()
export class UserLoginService {

    private _isLoggedIn : boolean = false;
    private isServer: boolean;
    private _loginName: string;
    private _oauthSubscription: Subscription
    private _state: object = {green: "green"};
    private _authConfig: AuthConfig;
    private _needsToken: boolean = true;
    public loginState: BehaviorSubject<String>;
    
    private _token_received_fired = false;

    constructor(
        private oauthService: OAuthService,
        //private coreEffects: CoreEffects,
        private interactions : EventInteraction,
        private location: Location,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(APP_SETTINGS) private settings: any
    ) {
        this.isServer = isPlatformServer(this.platformId);
        if (!this.isServer){
            this.loginState = new BehaviorSubject("init");
        }
        const self = this;
        this._oauthSubscription = this.oauthService.events.subscribe(e => {
            if (e.type !== 'invalid_nonce_in_state'){
    
               
                const loginStatusValue = this.loginState.getValue();
                if (!loginStatusValue || loginStatusValue != e.type){
                    const msg = (e.type == 'discovery_document_loaded' && self.hasAuthToken()) ? 'token_received' : e.type;
                    
                    self.interactions.next({ key: "oauth", message: { oauthStatus: msg } });
                    if (msg != 'token_received' || (msg === 'token_received' && !self._token_received_fired)){
                        if (msg !== 'discovery_document_loaded'){
                            self.loginState.next(msg);
                            if (msg === 'token_received'){
                                self._needsToken = false;
                                self._token_received_fired = true;
                                self.checkLoginStatus();
                            }
                            if (msg === 'logout'){
                                self.checkLoginStatus();
                                const cleanUrl = self.location.path(false);
                                self.location.replaceState(cleanUrl);
                                self._needsToken = true;
                            }
                        }

                    }
                }
                
                //console.log(e);
                
            }
        })
    }

    public initOAuth(isLogin: boolean = true){
        const url = this.router.url;
        const loginTarget = (url.indexOf('users/') < 0) ? window.location.origin + window.location.pathname + window.location.search : window.location.origin;
        this._authConfig = {
            // Url of the Identity Provider
            issuer: this.settings.AUTH_CONFIG.issuer,
            // URL of the SPA to redirect the user to after login
            redirectUri: (isLogin) ? loginTarget : window.location.origin + '/index.html',
            silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
            clearHashAfterLogin: true,
            // The SPA's id. The SPA is registerd with this id at the auth-server
            clientId: this.settings.AUTH_CONFIG.clientId,
            dummyClientSecret: this.settings.AUTH_CONFIG.dummyClientSecret,
            // set the scope for the permissions the client should request
            // The first three are defined by OIDC. The 4th is a usecase-specific one
            scope: this.settings.AUTH_CONFIG.scope,
        }
        this.configureWithNewConfigApi();  
    }

    private configureWithNewConfigApi() {
        if (!this.isServer){
            this.oauthService.configure(this._authConfig);
            this.oauthService.setStorage(localStorage);
            this.oauthService.tokenValidationHandler = new JwksValidationHandler();
            try{
                this.oauthService.loadDiscoveryDocumentAndTryLogin({
                    onTokenReceived: (info) => {
                        const receivedState = atob(info.state);
                        //console.log('state', receivedState);
                        this.oauthService.setupAutomaticSilentRefresh();
                        }
                    });
                
            }
            catch(oops){}

        }
    }
    
    public toggleLoginState() {
        if(this._isLoggedIn)
        {
            this.logout();
        }
        else
        {
            this.login();
        }
    }

    public login(){
        this.initOAuth(true);
        const serializedState = btoa(JSON.stringify(this._state));
        this.oauthService.initImplicitFlow(serializedState);
    }

    public logout() {
        //this.initOAuth(false);
        this.oauthService.logOut();
        this._isLoggedIn = false;
        this._loginName = null;
    }

    public get loginName(): string {
        return this._loginName;
    }

    public get authToken(): any {
        return this.oauthService.getAccessToken();
    }


    public get isLoggedIn(): boolean {
        return this._isLoggedIn;
    }

    public hasAuthToken(){
        try {
           return this.oauthService.hasValidAccessToken();
        }
        catch(e){
            return false;
        }
    }

    public checkLoginStatus(){
        if(!this.isServer && this.hasAuthToken())
        {
            if (!this.isLoggedIn){
                let claims = this.oauthService.getIdentityClaims();
                if (claims)
                {
                    this._loginName = claims["email"];
                }
                this._isLoggedIn = true;    
            }

        }
        else{
            if (this.isLoggedIn){
                this._isLoggedIn = false;
                this._loginName = null;
            }
        }
    }

    public setLoginState(state: boolean){
        this._isLoggedIn = state;
    }
}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/user/user.login.service.ts